import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-413363bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "festival"
}
const _hoisted_2 = { class: "festival-container" }
const _hoisted_3 = { class: "festival__banner" }
const _hoisted_4 = { class: "location" }
const _hoisted_5 = { class: "festival__group" }
const _hoisted_6 = { class: "festival__copy" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "festival__footer" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "button-row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon--gift" }, null, -1))
const _hoisted_13 = { class: "text" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon--link-arrow" }, null, -1))
const _hoisted_15 = {
  key: 1,
  class: "unlock-time"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unlock-time__icon" }, null, -1))

import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import dayjs from 'dayjs';
import { useWorkshop, useInfo } from '@/store';
import { useBackgroundUrl } from '../useWorkshopImg';
// components
import Button, { WorkShopButton } from '@/components/workshop/Button';


export default /*#__PURE__*/_defineComponent({
  __name: 'main',
  setup(__props) {

_useCssVars(_ctx => ({
  "fb63d9bc": (_unref(festivalBg).mobile),
  "e50a7e34": (_unref(festivalBg).tablet),
  "3dae5f1a": (_unref(festivalBg).pc),
  "3cfeaadb": (_unref(festivalBanner).mobile),
  "482b589f": (_unref(festivalBanner).tablet),
  "4dc42cac": (_unref(festivalBanner).pc),
  "21e34dcd": (_unref(festivalTitleLine).mobile),
  "3e78682b": (_unref(iconLinkArrow).mobile),
  "7dea77f6": (_unref(iconGift).mobile),
  "24546b84": (_unref(unlockToast).mobile)
}))

const {
  festivalBg,
  festivalBanner,
  festivalTitleLine,
  iconLinkArrow,
  iconGift,
  unlockToast,
} = useBackgroundUrl();
const { eventEntrance, storageToken } = storeToRefs(useWorkshop());
const { region, lang } = storeToRefs(useInfo());
const RETURN_PARAMS = 'from=anniversary';

const entranceLink = computed(() => {
  const map: { [key: string]: string | null } = {
    ['access_token']: storageToken.value,
    lang: lang.value,
    region: region.value,
  };
  let str = '';
  for (let i = 0; i < Object.keys(map).length; i++) {
    const key = Object.keys(map)[i];
    if (map[key]) str += `&${key}=${map[key]}`;
  }

  return `${eventEntrance.value?.eventLink}/?${str.slice(1)}&${RETURN_PARAMS}`;
});

const dateFormate = computed(() => {
  const lowercaseRegion = region.value?.toLowerCase();
  if (lowercaseRegion === 'zh-tw' || lowercaseRegion === 'ja') {
    return 'YYYY/MM/DD HH:mm:ss';
  }
  return 'DD/MM/YYYY HH:mm:ss';
});

const unlockTime = computed(() => {
  const timestamp = Number(eventEntrance.value?.unlockTime) * 1000;

  return dayjs(timestamp).format(dateFormate.value);
});

return (_ctx: any,_cache: any) => {
  return (_unref(eventEntrance))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('IW_LOCATION')), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(eventEntrance).name), 1),
              _createElementVNode("div", {
                class: "desc",
                innerHTML: _unref(eventEntrance).description
              }, null, 8, _hoisted_8)
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_unref(eventEntrance).eventLink)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: _unref(entranceLink),
                    target: "_blank"
                  }, [
                    _createVNode(_unref(Button), {
                      class: "festival__footer-button",
                      type: _unref(WorkShopButton).Get
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_11, [
                          _hoisted_12,
                          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('IW_P4_GOTO')), 1),
                          _hoisted_14
                        ])
                      ]),
                      _: 1
                    }, 8, ["type"])
                  ], 8, _hoisted_10))
                : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _hoisted_16,
                    _createTextVNode(" " + _toDisplayString(_unref(unlockTime)), 1)
                  ]))
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})